var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.sortIcon(_vm.sortTyp) && _vm.currentSortDir === 'asc')?_c('font-awesome-icon',{attrs:{"icon":['fad', 'sort-up']}}):_vm._e(),(_vm.sortIcon(_vm.sortTyp) && _vm.currentSortDir === 'desc')?_c('font-awesome-icon',{attrs:{"icon":['fad', 'sort-down']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }